import { useState } from 'react';
import {
  Card, Typography, Upload, Button, Alert, Space,
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useMutation } from 'react-query';
import httpService from 'services/http.service';
import { API_URLS } from 'config/constants';

const { Title, Text } = Typography;

async function uploadCsv(file: File): Promise<{ parsedOverpriced: number; markedInDb: number; cleared: number; totalRows: number; skippedRows: number }> {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await httpService.post(API_URLS.FEED.PRICE_COMPETITIVENESS, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

const PriceCompetitivenessPage = () => {
  const [result, setResult] = useState<{ parsedOverpriced: number; markedInDb: number; cleared: number; totalRows: number; skippedRows: number } | null>(null);

  const { mutate, isLoading, isError, error } = useMutation(uploadCsv, {
    onSuccess: (data) => setResult(data),
  });

  return (
    <Card style={{ maxWidth: 600, margin: '24px auto' }}>
      <Title level={4}>Price Competitiveness</Title>
      <Space direction='vertical' size='middle' style={{ width: '100%' }}>
        <Text type='secondary'>
          Завантажте CSV звіт з Google Merchant Center (Price Competitiveness Report).
          Товари де ваша ціна вища за ринкову більш ніж на 10% будуть позначені як overpriced
          і не потраплять у Google Shopping фід при наступній генерації.
        </Text>
        <Upload
          accept='.csv,.tsv,.txt'
          showUploadList={false}
          beforeUpload={(file) => {
            setResult(null);
            mutate(file);
            return false;
          }}
        >
          <Button icon={<UploadOutlined />} loading={isLoading} size='large' type='primary'>
            Завантажити CSV
          </Button>
        </Upload>
        {result && (
          <Alert
            type='success'
            message='Готово!'
            description={`Всього рядків: ${result.totalRows} · Пропущено: ${result.skippedRows} · Знайдено overpriced у CSV: ${result.parsedOverpriced} · Збережено в БД: ${result.markedInDb} · Знято позначку: ${result.cleared}`}
            showIcon
          />
        )}
        {isError && (
          <Alert
            type='error'
            message='Помилка'
            description={(error as any)?.message || 'Невідома помилка'}
            showIcon
          />
        )}
      </Space>
    </Card>
  );
};

export default PriceCompetitivenessPage;
